var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"header-logo"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.logo}})]),_c('h1',{staticClass:"header-title"},[_vm._v("International Feedback Management")])])]),_c('UserBadge')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }